import { PrettyPost } from '../util/PrettyPost'

export const FACEBOOK_AVATAR =
  '/static/img/facebook-posts/301859317_114267908066132_5079637478690893955_n.jpeg'

const FACEBOOK_POSTS: PrettyPost[] = [
  {
    id: '104306382395618_283446941157900',
    url: 'https://www.facebook.com/135810155921580/posts/283446941157900',
    message: 'Prima piesă cu degetele pe coardă: Ritmul cu 3 degete.',
    creationTime: '2023-09-30T11:38:59+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'video_inline',
        url: 'https://www.facebook.com/135810155921580/videos/311171658218538',
        width: 720,
        height: 405,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_283446941157900_0.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_258462510323010',
    url: 'https://www.facebook.com/135810155921580/posts/258462510323010',
    message: 'Musical fingerplay with my 2 month old baby!',
    creationTime: '2023-08-16T15:42:43+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'video_inline',
        url: 'https://www.facebook.com/reel/1709112619590545/',
        width: 720,
        height: 405,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_258462510323010_0.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_234849609350967',
    url: 'https://www.facebook.com/135810155921580/posts/234849609350967',
    message:
      'Happy July 4th! My little Theo is 3 weeks old and is starting to develop colic. He is fussy and prefers to be held rather than stay in baby swings or rockers. The only problem is- he weighs almost 10 pounds (4.5 kilos)! Here is a little song I invented yesterday morning when he refused to stay in the baby swing (again!).\n\nI call it... Tired and Bored...?',
    creationTime: '2023-07-04T15:49:11+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'video_inline',
        url: 'https://www.facebook.com/135810155921580/videos/329198336098077',
        width: 405,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_234849609350967_0.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_228354966667098',
    url: 'https://www.facebook.com/135810155921580/posts/228354966667098',
    message:
      "I'm a Mommy! Here is little Theofil. He already listens to Peter and the Wolf, Pictures at an Exhibition and Britten's Young Person's Guide to the Orchestra. The music education is already starting. 🥰",
    creationTime: '2023-06-23T14:15:21+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'album',
        url: 'https://www.facebook.com/135810155921580/posts/228354966667098',
        width: 720,
        height: 960,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_228354966667098_0.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=228354853333776&set=a.120472570788672&type=3',
        width: 720,
        height: 960,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_228354966667098_1.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=228354900000438&set=a.120472570788672&type=3',
        width: 960,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_228354966667098_2.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=228354850000443&set=a.120472570788672&type=3',
        width: 720,
        height: 960,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_228354966667098_3.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_207215028781092',
    url: 'https://www.facebook.com/135810155921580/posts/207215028781092',
    message:
      "Today at the Centrul de zi pentru copii Sfântă Marina I received some sweet cards and flowers from the children. I've been teaching Music Therapy there for a year now! But since baby boy will be born anytime now, they wanted to say good luck! Centrul de zi pentru copii Sfanta Marina Iasi",
    creationTime: '2023-05-18T12:56:51+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'album',
        url: 'https://www.facebook.com/135810155921580/posts/207215028781092',
        width: 720,
        height: 1512,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_207215028781092_0.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=207213382114590&set=a.120472570788672&type=3',
        width: 720,
        height: 1512,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_207215028781092_1.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=207213352114593&set=a.120472570788672&type=3',
        width: 720,
        height: 839,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_207215028781092_2.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=207213328781262&set=a.120472570788672&type=3',
        width: 720,
        height: 960,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_207215028781092_3.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=207213318781263&set=a.120472570788672&type=3',
        width: 720,
        height: 960,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_207215028781092_4.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=207213395447922&set=a.120472570788672&type=3',
        width: 720,
        height: 960,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_207215028781092_5.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=207213508781244&set=a.120472570788672&type=3',
        width: 720,
        height: 897,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_207215028781092_6.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_195475013288427',
    url: 'https://www.facebook.com/135810155921580/posts/195475013288427',
    message:
      'One way we practice our bow-hold is through games (that provide a great reward at the end of the lesson!). This game is called the Cup Game. Similar to "hot potato", we pass the cup back and forth while a song plays and whoever has the cup when the song ends has to do 10 jumping jacks!',
    creationTime: '2023-04-28T10:40:55+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'album',
        url: 'https://www.facebook.com/135810155921580/posts/195475013288427',
        width: 1080,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_195475013288427_0.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=195474623288466&set=a.120472570788672&type=3',
        width: 1080,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_195475013288427_1.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=195474613288467&set=a.120472570788672&type=3',
        width: 1080,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_195475013288427_2.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=195474569955138&set=a.120472570788672&type=3',
        width: 1080,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_195475013288427_3.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=195474596621802&set=a.120472570788672&type=3',
        width: 1080,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_195475013288427_4.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=195474603288468&set=a.120472570788672&type=3',
        width: 1080,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_195475013288427_5.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_192836146885647',
    url: 'https://www.facebook.com/135810155921580/posts/192836146885647',
    message:
      'Today was Natalia\'s 8th lesson and we started the "concerto de la" (A string concerto) for the first time. In lesson 5 we started playing the "mămăligă brânză" rhythm with the bow for the first time, and in lesson 6 we started "concerto de mi" (E string concerto). Next week we will talk about "vecinii zgomotoși" i.e. "noisy neighbors". Noisy neighbors are when you play the neighboring strings by accident, adding extra noise to your sound. The challenge for the "concerto de la" is to play without any noisy neighbors!',
    creationTime: '2023-04-23T16:16:23+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'video_inline',
        url: 'https://www.facebook.com/reel/253102237113463/',
        width: 720,
        height: 405,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_192836146885647_0.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_171006379068624',
    url: 'https://www.facebook.com/135810155921580/posts/171006379068624',
    message:
      'Back in January we were learning about rhythmical palindromes and learning a body percussion song at the Centrul de Zi Pentru Copii Sfanta Marina!',
    creationTime: '2023-03-16T15:22:47+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'album',
        url: 'https://www.facebook.com/467943638795390/posts/541393791450374',
        width: 959,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_171006379068624_0.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=541393731450380&set=a.425460199710401&type=3',
        width: 959,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_171006379068624_1.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=541393718117048&set=a.425460199710401&type=3',
        width: 720,
        height: 959,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_171006379068624_2.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_162125606623368',
    url: 'https://www.facebook.com/135810155921580/posts/162125606623368',
    message:
      'This little song, to the tune of Song of the Wind or Vulpe Tu Mi-ai Furat Gâsca, teaches the violin bowhold in a fun way! I learned this song from another teacher and used it for many years in group violin lessons in Boston. Now I made a Romanian version for my young violin students who enjoy singing. The English version is also slightly modified from the version I learned originally to better fit my curriculum needs. I hope you enjoy it! (P.S. there are subtitles in English and Romanian) (P.P.S. my Romanian is still a work in progress, forgive the accent!) ',
    creationTime: '2023-03-01T15:55:21+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'share',
        url: 'https://l.facebook.com/l.php?u=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DdMmFeZH_ROI&h=AT39yBZ_pOMLFBBCKlpdPbA8YAGljfa1GKU0gjG730tVnFklc5D-QgJTHx1BTgGNeYvgWdsqROZYt_1aLi9utbATevLXRio1XE-g3sQejf8svesLW_S87c1bQ5m7ejDd&s=1',
        width: 360,
        height: 360,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_162125606623368_0.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_154521587383770',
    url: 'https://www.facebook.com/135810155921580/posts/154521587383770',
    message:
      'Folosesc acest cântec în prima lecția de vioară cu copii mici să învățăm părțile viorii. Melodia este de fapt the Monkey Song care cântăm la vioară mai târziu!',
    creationTime: '2023-02-04T13:38:27+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'video_inline',
        url: 'https://www.facebook.com/135810155921580/videos/818141119831910',
        width: 720,
        height: 405,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_154521587383770_0.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_150040327831896',
    url: 'https://www.facebook.com/135810155921580/posts/150040327831896',
    message:
      'How to install fine-tuners on your violin! Seven simple steps! Cum se instalează fixurile de vioară pe vioară! Șapte pași simpli!\n\nMusic by https://www.free-stock-music.com',
    creationTime: '2023-01-17T16:25:07+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'video_inline',
        url: 'https://www.facebook.com/135810155921580/videos/703719771416030',
        width: 720,
        height: 405,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_150040327831896_0.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_149779171191345',
    url: 'https://www.facebook.com/135810155921580/posts/149779171191345',
    message: 'Terapie muzicală',
    creationTime: '2023-01-16T13:17:40+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'album',
        url: 'https://www.facebook.com/467943638795390/posts/505993631657057',
        width: 959,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_149779171191345_0.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=505993591657061&set=a.425460196377068&type=3',
        width: 959,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_149779171191345_1.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=505993618323725&set=a.425460196377068&type=3',
        width: 762,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_149779171191345_2.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_136612999174629',
    url: 'https://www.facebook.com/135810155921580/posts/136612999174629',
    message:
      "Throw-back to an old video- the Melc song! I didn't speak Romanian as well back then so it took some work to learn the words in Romanian and translate them! ",
    creationTime: '2022-11-25T12:40:43+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'share',
        url: 'https://l.facebook.com/l.php?u=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DLJXejdfZXTk&h=AT1pnqyw1dh4XSpOOZtjhfRZdvAPE0d0z1Pl7bqbQ3vzbslDmHCxG0EqCPLnK_Uk6UQqadjS4zuGHkW1SMq2zWLtCplye3_G3Vdx374gvWMAyotrv7rHNtQy5p-L-a0l&s=1',
        width: 720,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_136612999174629_0.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_135858365916759',
    url: 'https://www.facebook.com/135810155921580/posts/135858365916759',
    creationTime: '2022-11-22T15:42:45+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'video_inline',
        url: 'https://www.facebook.com/467943638795390/videos/1147871689168681',
        width: 640,
        height: 368,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_135858365916759_0.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_134599119376017',
    url: 'https://www.facebook.com/135810155921580/posts/134599119376017',
    message: 'Preparing the violin homework page with my little sleepy helper keeping me company.',
    creationTime: '2022-11-17T18:39:57+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'album',
        url: 'https://www.facebook.com/135810155921580/posts/134599119376017',
        width: 343,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_134599119376017_0.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=134599059376023&set=a.120472570788672&type=3',
        width: 343,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_134599119376017_1.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=134599082709354&set=a.120472570788672&type=3',
        width: 343,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_134599119376017_2.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_132957072873555',
    url: 'https://www.facebook.com/135810155921580/posts/132957072873555',
    message:
      '"Voi zice 1, 2, 3, și imediat după, ziceți, în același timp, dacă preferați Youtube sau Tiktok! 1, 2, 3!..." \n"I\'m going to say 1, 2, 3, and immediately after, at the same time, say whether you prefer Youtube or Tiktok! 1, 2, 3!.."',
    creationTime: '2022-11-11T11:18:34+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'album',
        url: 'https://www.facebook.com/467943638795390/posts/459687602954327',
        width: 541,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_132957072873555_0.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=459687256287695&set=a.425460196377068&type=3',
        width: 541,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_132957072873555_1.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=459687336287687&set=a.425460196377068&type=3',
        width: 541,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_132957072873555_2.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=459687386287682&set=a.425460196377068&type=3',
        width: 719,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_132957072873555_3.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=459687432954344&set=a.425460196377068&type=3',
        width: 719,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_132957072873555_4.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=459687492954338&set=a.425460196377068&type=3',
        width: 720,
        height: 541,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_132957072873555_5.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=459687532954334&set=a.425460196377068&type=3',
        width: 541,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_132957072873555_6.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=459687569620997&set=a.425460196377068&type=3',
        width: 720,
        height: 541,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_132957072873555_7.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_132684942900768',
    url: 'https://www.facebook.com/135810155921580/posts/132684942900768',
    message:
      "I'm preparing for my weekly music lesson at the Centru de Zi Pentru Copii Sfânta Marina. Today we will be doing: \n1. Boom Snap Clap (very fun and simple motion song) https://www.youtube.com/watch?v=UkFs5glUMjw&list=PPSV\n2. Dalcroze-inspired body percussion rhythms in 4/4 time.\n3. Dalcroze meter activity exploring 2 versus 3.\nThis is my first time teaching the third activity so I am excited to see what the kids think!",
    creationTime: '2022-11-10T11:12:29+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=132684819567447&set=a.120472570788672&type=3',
        width: 720,
        height: 343,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_132684942900768_0.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_123824687120127',
    url: 'https://www.facebook.com/135810155921580/posts/123824687120127',
    message:
      'The week of Sept 26-30, I visited the beautiful Elijah El Sistema music program near Sibiu, Romania. I met so many wonderful people and loved working with the children there. Their program is wonderful and the children are really benefiting from the loving care. To learn more about Elijah you can visit their website https://elijah.ro/en/projekte/our-work/music-schools/ or their facebook page https://www.facebook.com/profile.php?id=100071232412278 Asociatia Elijah',
    creationTime: '2022-10-09T09:04:37+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'album',
        url: 'https://www.facebook.com/135810155921580/posts/123824687120127',
        width: 720,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_123824687120127_0.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=123824297120166&set=a.120472570788672&type=3',
        width: 720,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_123824687120127_1.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=123824303786832&set=a.120472570788672&type=3',
        width: 720,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_123824687120127_2.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=123824307120165&set=a.120472570788672&type=3',
        width: 720,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_123824687120127_3.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=123824373786825&set=a.120472570788672&type=3',
        width: 720,
        height: 392,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_123824687120127_4.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=123824393786823&set=a.120472570788672&type=3',
        width: 720,
        height: 392,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_123824687120127_5.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/photo.php?fbid=123824497120146&set=a.120472570788672&type=3',
        width: 720,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_123824687120127_6.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_122207967272126',
    url: 'https://www.facebook.com/104306382395618/posts/122207967272126/',
    message: 'And today we tried some body percussion and rhythms!',
    creationTime: '2022-09-20T15:50:49+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'album',
        url: 'https://www.facebook.com/219564621462242/posts/5518633938221924/',
        width: 538,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122207967272126_0.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/centruldezipentrucopiisfantamarinaiasi/photos/a.515292228556145/5518628531555798/?type=3',
        width: 538,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122207967272126_1.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/centruldezipentrucopiisfantamarinaiasi/photos/a.515292228556145/5518628568222461/?type=3',
        width: 719,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122207967272126_2.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/centruldezipentrucopiisfantamarinaiasi/photos/a.515292228556145/5518628618222456/?type=3',
        width: 719,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122207967272126_3.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/centruldezipentrucopiisfantamarinaiasi/photos/a.515292228556145/5518628601555791/?type=3',
        width: 719,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122207967272126_4.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/centruldezipentrucopiisfantamarinaiasi/photos/a.515292228556145/5518628881555763/?type=3',
        width: 538,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122207967272126_5.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_122185260607730',
    url: 'https://www.facebook.com/104306382395618/posts/122185260607730/',
    message: 'Building up our musical muscles!',
    creationTime: '2022-09-20T14:33:09+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'album',
        url: 'https://www.facebook.com/219564621462242/posts/5487296501355668/',
        width: 720,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122185260607730_0.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/centruldezipentrucopiisfantamarinaiasi/photos/a.3513572072061464/5487295938022391/?type=3',
        width: 720,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122185260607730_1.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/centruldezipentrucopiisfantamarinaiasi/photos/a.3513572072061464/5487296114689040/?type=3',
        width: 720,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122185260607730_2.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/centruldezipentrucopiisfantamarinaiasi/photos/a.3513572072061464/5487296244689027/?type=3',
        width: 720,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122185260607730_3.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/centruldezipentrucopiisfantamarinaiasi/photos/a.3513572072061464/5487296344689017/?type=3',
        width: 720,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122185260607730_4.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/centruldezipentrucopiisfantamarinaiasi/photos/a.3513572072061464/5487296458022339/?type=3',
        width: 719,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122185260607730_5.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_122185130607743',
    url: 'https://www.facebook.com/104306382395618/posts/122185130607743/',
    message:
      'Working on a routine and building a relationship with the children at the Centrul de Zi Pentru Copii here in Iași. I think we are getting there!',
    creationTime: '2022-09-20T14:32:28+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'album',
        url: 'https://www.facebook.com/219564621462242/posts/5517646751653976/',
        width: 719,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122185130607743_0.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/centruldezipentrucopiisfantamarinaiasi/photos/a.3513572072061464/5517646474987337/?type=3',
        width: 719,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122185130607743_1.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/centruldezipentrucopiisfantamarinaiasi/photos/a.3513572072061464/5517646588320659/?type=3',
        width: 719,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122185130607743_2.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/centruldezipentrucopiisfantamarinaiasi/photos/a.3513572072061464/5517646674987317/?type=3',
        width: 719,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_122185130607743_3.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_117346974424892',
    url: 'https://www.facebook.com/104306382395618/posts/117346974424892/',
    message:
      "I had a busy end of the week last week! On Thursday I went to a rehearsal for my first playing gig in Romania: the inauguration of a private school. On Friday I taught at the Centru de Zi Pentru Copii, and on Saturday the inauguration lasted from 10 am until 5 pm! I took some photos of my viola's journey far across the city to the gig.",
    creationTime: '2022-09-05T09:17:32+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'album',
        url: 'https://www.facebook.com/104306382395618/posts/117346974424892/',
        width: 719,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_117346974424892_0.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/MusicwithMsJohnson/photos/a.114266918066231/117346907758232/?type=3',
        width: 719,
        height: 540,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_117346974424892_1.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/MusicwithMsJohnson/photos/a.114266918066231/117357654423824/?type=3',
        width: 720,
        height: 417,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_117346974424892_2.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/MusicwithMsJohnson/photos/a.114266918066231/117346817758241/?type=3',
        width: 343,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_117346974424892_3.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/MusicwithMsJohnson/photos/a.114266918066231/117346781091578/?type=3',
        width: 343,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_117346974424892_4.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/MusicwithMsJohnson/photos/a.114266918066231/117346757758247/?type=3',
        width: 343,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_117346974424892_5.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_114266931399563',
    url: 'https://www.facebook.com/104306382395618/posts/114266931399563/',
    message:
      'I had a great time this week teaching little Tudor. As usual, we talked about correct posture, practiced maintaining a good bow hold and sang solfege. It is his ninth lesson and he is learning how to play the A String Concerto without "noisy neighbors" (hitting the neighboring strings with his bow). He is making great progress!',
    creationTime: '2022-08-27T15:12:54+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'album',
        url: 'https://www.facebook.com/104306382395618/posts/114266931399563/',
        width: 480,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_114266931399563_0.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/MusicwithMsJohnson/photos/a.114266918066231/114266574732932/?type=3',
        width: 480,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_114266931399563_1.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/MusicwithMsJohnson/photos/a.114266918066231/114266641399592/?type=3',
        width: 480,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_114266931399563_2.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/MusicwithMsJohnson/photos/a.114266918066231/114266538066269/?type=3',
        width: 720,
        height: 480,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_114266931399563_3.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/MusicwithMsJohnson/photos/a.114266918066231/114266571399599/?type=3',
        width: 720,
        height: 480,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_114266931399563_4.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/MusicwithMsJohnson/photos/a.114266918066231/114266614732928/?type=3',
        width: 720,
        height: 480,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_114266931399563_5.jpeg'
      },
      {
        type: 'photo',
        url: 'https://www.facebook.com/MusicwithMsJohnson/photos/a.114266918066231/114266844732905/?type=3',
        width: 720,
        height: 480,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_114266931399563_6.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_108413605318229',
    url: 'https://www.facebook.com/104306382395618/posts/108413605318229/',
    message:
      "Hey everyone, Facebook thinks I stole the viola recording from Kim Kashkashian (hardy har har) and muted my video so while I'm disputing that silliness, you can watch my video on Youtube! https://www.youtube.com/watch?v=XQ-yVsm80Ec",
    creationTime: '2022-08-18T15:52:53+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'share',
        url: 'https://l.facebook.com/l.php?u=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DXQ-yVsm80Ec&h=AT0CIwwlX_D1ehd47_vQyGN2JH05ev9sySiIT3ZtwCkFqJdib1TefNzNo8a_Mujtw36-2TX9psI74ErehAIBGqlEPPPUdQ7Rsa-npTpmmyU69Uy4S_lzVEx61cIbBfRE&s=1',
        width: 360,
        height: 360,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_108413605318229_0.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_108402858652637',
    url: 'https://www.facebook.com/104306382395618/posts/108402858652637/',
    message:
      "In this video I'm playing the Gigue from Bach's Suite no. 3 for solo cello arranged for viola, as well as packing for a picnic. Children can learn the form of the piece naturally and instinctively as they pack for a picnic, get excited about cake and worry about silly little things with me. This activity is my original creation, and is very silly.",
    creationTime: '2022-08-18T15:43:09+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'video_inline',
        url: 'https://www.facebook.com/135810155921580/videos/1047904176085096',
        width: 720,
        height: 405,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_108402858652637_0.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_106630265496563',
    url: 'https://www.facebook.com/104306382395618/posts/106630265496563/',
    message:
      'A cute video with a traditional Romanian song and drawing patterns in rhythm. Such a great idea! https://youtu.be/KkRSfGXz4vg',
    creationTime: '2022-08-16T12:05:15+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'share',
        url: 'https://l.facebook.com/l.php?u=https%3A%2F%2Fyoutu.be%2FKkRSfGXz4vg&h=AT2ADC5dwGHRa1HCKlpOcNJZznMmdtW6i62ev9Kj2l4d0TdfwpUOEJR8rbojlLx0s7KQKtY5dDMI6EW5JA2FmcSb-r8Btu1geoQtSBwS1TYTSD5sPFCCt5D8hWab__ug&s=1',
        width: 720,
        height: 720,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_106630265496563_0.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_105327118960211',
    url: 'https://www.facebook.com/104306382395618/posts/105327118960211/',
    message:
      "Last month I posted this video on my Youtube Channel (Music with Ms. Johnson). Oac Oac is a Romanian children's song, and it is the second Romanian children's song I ever learned (the first being Melc Melc Codobelc!). This is my own arrangement and my own translation and adaptation of the Romanian lyrics to English. To hear the song in the original Romanian, see my other video https://fb.watch/eUQMl2aq7R/ . \n\nEnglish lyrics:\n\nWhat a great day for a party\nIn the middle of the lake\nAll the frogs and all the toadies\nDrink hot chocolate and eat cake\n\nOac oac diri-diri-dam\nOac-oac oac-oac diri-diri-dam\nOac oac diri-diri-dam\nOac-oac oac-oac diri-diri-dam\n\n \nTom the toad plays on the fiddle\nFred the frog plays upright bass\nTiny tadpoles jump and wiggle\nAll the frogs join in the pace \n\nOac oac diri-diri-dam\nOac-oac oac-oac diri-diri-dam\nOac oac diri-diri-dam\nOac-oac oac-oac diri-diri-dam\n\nFrom the tall reeds sniffing slowly\nComes a little limping dog\nAll the frogs jump squawking loudly\nNow there’s not a single frog\n\nOac oac diri-diri-dam\nOac-oac oac-oac diri-diri-dam\nOac oac diri-diri-dam\nOac-oac oac-oac diri-diri-dam\nOac oac diri-diri-dam\nOac-oac oac-oac diri-diri-dam\nOac oac diri-diri-dam\nOac-oac oac-oac diri-diri-dam",
    creationTime: '2022-08-14T15:41:30+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'video_inline',
        url: 'https://www.facebook.com/135810155921580/videos/795595725199976',
        width: 720,
        height: 405,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_105327118960211_0.jpeg'
      }
    ]
  },
  {
    id: '104306382395618_104310712395185',
    url: 'https://www.facebook.com/104306382395618/posts/104310712395185/',
    creationTime: '2022-08-13T07:41:35+0000',
    userName: 'Susanna Johnson-Chelaru',
    attachments: [
      {
        type: 'share',
        url: 'https://facebook.com/MusicwithMsJohnson',
        width: 720,
        height: 450,
        thumbnailUrl: '/static/img/facebook-posts/104306382395618_104310712395185_0.jpeg'
      }
    ]
  }
]

export default FACEBOOK_POSTS
